import React from "react";
import { useSelector } from "react-redux";
import { isMobile, normalizeString } from "../../Common/utils";
import { currentFixture } from "../../Common/utils/fixture";
import RaceThumbnail from "../Cloudinary/RaceThumbnail";

const MatchHeaderThumbnail = () => {
  // const [index, setIndex] = useState(0);
  const fixtureCircuitConfigState = useSelector(
    (state) => state.fixtureCircuitConfig
  );
  const fixtures = fixtureCircuitConfigState?.data?.fixtures;
  const circuits = fixtureCircuitConfigState?.data?.circuit;
  const currentCircuit = circuits?.find(
    (x) => x?.MeetingId === currentFixture(fixtures)?.MeetingId
  );

  // const currentFixture = fixtureState?.list?.find((x) => x.MHIsCurrent == 1);

  // const currentFixture = fixtureState?.list && fixtureState?.list[index];
  // const [maxFixtures, setMaxFixtures] = useState(null);

  // useEffect(() => {
  //   setMaxFixtures(fixtureState?.list?.length);
  // }, [fixtureState]);

  // function refreshFixture() {
  //   console.log(index, maxFixtures);
  //   if (index <= maxFixtures) {
  //     setIndex((prev) => prev + 1);
  //   }
  // }
  // useEffect(() => {
  //   const timerId = setInterval(refreshFixture, 1000);
  //   return function cleanup() {
  //     clearInterval(timerId);
  //   };
  // }, []);
  return (
    <>
      {!isMobile() && (
        <div className="si-matchHeader__thumbnail">
          <RaceThumbnail
            countryName={normalizeString(currentCircuit?.CircuitShortName)}
          />
        </div>
      )}
    </>
  );
};

export { MatchHeaderThumbnail };
